import { buildRpaDomainSeoBundle } from "../rpaSeoUtils";

export const AVIATION_DOMAIN_INTRO = {
  title: "Aviation & Aerospace",
  content: "Document AI + RPA and workflow automation across Air Cargo, MRO. Each use case includes challenge and solution detail, process diagrams, and human-in-the-loop review for enterprises in India, UAE, KSA, UK, and USA.",
  seoDescription: "Aviation & Aerospace automation use cases — document AI + RPA and workflow automation across Air Cargo, MRO. Validation, approvals, system updates, and exception handling.",
};

const slugify = (label) =>
  label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) {
  return {
    ...uc,
    groupId: slugify(uc.subIndustry),
    seoTitle: uc.title,
    title: uc.shortTitle || uc.title,
    systems: uc.systems || SYSTEMS,
  };
}

const SYSTEMS = "MRO System, Crew Management, Safety Management, Document Management, Email, Power BI";

const RAW = [
  {
    id: "cargo-document-processing",
    subIndustry: "Air Cargo",
    department: "Documentation",
    businessProcess: "Cargo document processing",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Cargo document processing",
    title: "Cargo Document Processing Automation for Aviation & Aerospace",
    seoKeywords: "aviation & aerospace, cargo document processing, AI automation, RPA, agentic AI, document AI",
    challenge: "AWB, invoices, packing lists and dangerous goods documents are processed manually.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "Cargo Operations Head",
    systems: "Cargo System, ERP, Customs Portal, Email",
    agentsRequired: "Document Extraction Agent, Cargo Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and cargo document processing rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready cargo document processing record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "warranty-claim-preparation",
    subIndustry: "MRO",
    department: "Warranty",
    businessProcess: "Warranty claim preparation",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Warranty claim preparation",
    title: "Warranty Claim Preparation Automation for Aviation & Aerospace",
    seoKeywords: "aviation & aerospace, warranty claim preparation, AI automation, RPA, agentic AI, document AI",
    challenge: "Warranty claims are manually compiled from defects, parts, work orders and supplier terms.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "MRO Finance Head",
    systems: "MRO System, ERP, Supplier Portal, Contract Repository",
    agentsRequired: "Document Extraction Agent, Warranty Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and warranty claim preparation rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready warranty claim preparation record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "Medium",
  },
];
export const AVIATION_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Air Cargo", "MRO"];
export const AVIATION_GROUPS = GROUP_ORDER.map((label) => ({
  id: slugify(label),
  label,
})).filter((g) => AVIATION_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildRpaDomainSeoBundle({
  domainSlug: 'aviation-aerospace-domain',
  domainIntro: AVIATION_DOMAIN_INTRO,
  useCases: AVIATION_USE_CASES,
});
export const AVIATION_USE_CASES_SEO = seo.useCasesSeo;
export const AVIATION_DOMAIN_FAQS = seo.domainFaqs;
export const AVIATION_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const AVIATION_FAQ_JSONLD = seo.faqJsonLd;
export const AVIATION_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const AVIATION_WEBPAGE_JSONLD = seo.webPageJsonLd;

